import { useEffect, useRef, useState } from 'react';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import Script from 'next/script'
import { useAthenaSiteConfig } from '@/hooks/query/athena/use-athena-site-config';

export const GTMProvider = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const { data: athenaSiteConfig } = useAthenaSiteConfig();
	return (
		<>
			{
				!!SiteConfigsData?.GalaxyGAId &&
				<>
					<Script id="google-analytics-js" async src={`https://www.googletagmanager.com/gtag/js?id=${SiteConfigsData?.GalaxyGAId}`}>
					</Script>
					<Script id="google-analytics">
						{
							`window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({
									'GAID': '${SiteConfigsData?.GalaxyGAId}'
								});`
						}
					</Script>
				</>
			}
			{
				!!athenaSiteConfig?.LicenseeGAId &&
				<>
					<Script id="google-analytics-js" async src={`https://www.googletagmanager.com/gtag/js?id=${athenaSiteConfig?.LicenseeGAId}`}>
					</Script>
					<Script id="google-analytics">
						{
							`window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({
									'GAID': '${athenaSiteConfig?.LicenseeGAId}'
								});`
						}
					</Script>
				</>
			}
		</>
	)
};